/**
 * @description: 会员积分汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="mr-hjh-report">
        <div class="hjh-list">
            <el-form :inline="true" size="small" :model="hjh_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="hjh_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="hjh_list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="hjh_list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="hjh_list_form.shop_id" filterable clearable placeholder="请选择门店" @change="changeShop">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入内容" v-model="hjh_list_form.content">
                        <el-select class="el-slot-select" v-model="hjh_list_form.select" slot="prepend" placeholder="请选择">
                            <el-option label="会员卡号" value="vip_card"></el-option>
                            <el-option label="会员姓名" value="vip_name"></el-option>
                            <el-option label="会员手机号" value="vip_mobile"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="hjhQuery">查询</el-button>
                    <el-button @click="hjhExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="hjh_list">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="vip_card" label="会员卡号"></el-table-column>
                <el-table-column prop="vip_name" label="会员姓名"></el-table-column>
                <el-table-column prop="vip_mobile" label="会员手机号"></el-table-column>
                <el-table-column prop="total_points" label="积分获得"></el-table-column>
                <el-table-column prop="total_use_points" label="积分使用"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-6">积分获得总计:</label>
                    <div class="list-total">{{hjh_total_points}}</div>
                    <label class="list-label-6">积分使用总计:</label>
                    <div class="list-total">{{hjh_total_use_points}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="hjh_list_page"
                    :total="hjh_list_total"
                    @current-change="getHjhList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="hjh_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="hjh_export_sign" v-model="hjh_export_all" @change="hjhExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="hjh_export_ids" @change="hjhExportChange">
                    <el-checkbox label="shop_name">门店</el-checkbox>
                    <el-checkbox label="vip_card">会员卡号</el-checkbox>
                    <el-checkbox label="vip_name">会员姓名</el-checkbox>
                    <el-checkbox label="vip_mobile">会员手机号</el-checkbox>
                    <el-checkbox label="total_points">积分获得</el-checkbox>
                    <el-checkbox label="total_use_points">积分使用</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="hjh_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="hjh_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                hjh_list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    content: '',
                    select: 'vip_card'
                },
                hjh_total_points: '',
                hjh_total_use_points: '',
				hjh_list: [],
				hjh_list_page: 1,
                hjh_list_total: 0,
                hjh_export_sign: false,
				hjh_export_all: false,
                hjh_export_ids: [],
                hjh_export_list: ['shop_name', 'vip_card', 'vip_name', 'vip_mobile', 'total_points', 'total_use_points'],
                hjh_export_type: '1',
            }
        },
        mounted: function() {
            // 日期
            this.hjh_list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.hjh_list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.hjh_list_form.shop_id = this.shop_list[0].id;
                this.getHjhList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.hjh_list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.hjh_list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.hjh_list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.hjh_list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.hjh_list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit : {
                        days : 31
                    },
                }, function(start, end, label) {
                    _this.hjh_list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.hjh_list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            changeShop(val) {
                if (!!val) {
                    this.setShopDefaultTime(val)
                }
            },


            getHjhList(page) {
				const _this = this;

                _this.loading = true;
                let vip_card = "",
                    vip_name = "",
                    vip_mobile = "";
                if(_this.hjh_list_form.select == 'vip_card') {
                    vip_card = _this.hjh_list_form.content;
                } else if(_this.hjh_list_form.select == 'vip_name') {
                    vip_name = _this.hjh_list_form.content;
                } else if(_this.hjh_list_form.select == 'vip_mobile') {
                    vip_mobile = _this.hjh_list_form.content;
                }
				Vue.axios.post('FinanceReport2/vipPointsLogCount', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.hjh_list_form.start_time,
                            "end_time": _this.hjh_list_form.end_time,
                            "shop_id": _this.hjh_list_form.shop_id,
                            "vip_card": vip_card,
                            "vip_name": vip_name,
                            "vip_mobile": vip_mobile
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.hjh_list_total = Number(res.data.response.count);
							_this.hjh_total_points = res.data.response.total_points;
							_this.hjh_total_use_points = res.data.response.total_use_points;
						}
						_this.hjh_list = res.data.response.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			hjhQuery() {
				this.getHjhList(1);
            },
            // 导出
            hjhExportAll(val) {
				this.hjh_export_ids = val ? this.hjh_export_list : [];
				this.hjh_export_sign = false;
			},
			hjhExportChange(val) {
				const len = val.length;
				this.hjh_export_all = len === this.hjh_export_list.length;
				this.hjh_export_sign = len > 0 && len < this.hjh_export_list.length;
			},
            hjhExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "FinanceReport2/vipPointsLogCountExport"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.hjh_export_ids = res.data.response.result.export_fields;
                            _this.hjh_export_type = res.data.response.result.export_type;
                        } else {
                            _this.hjh_export_ids = _this.hjh_export_list;
                            _this.hjh_export_type = '1';
                        }
                        _this.hjhExportChange(_this.hjh_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.hjh_list_export)
                }, function() {
                    _this.hjhExport();
                });
            },
            hjhExport: function() {
                let vip_card = "",
                    vip_name = "",
                    vip_mobile = "";
                if(this.hjh_list_form.select == 'vip_card') {
                    vip_card = this.hjh_list_form.content;
                } else if(this.hjh_list_form.select == 'vip_name') {
                    vip_name = this.hjh_list_form.content;
                } else if(this.hjh_list_form.select == 'vip_mobile') {
                    vip_mobile = this.hjh_list_form.content;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/vipPointsLogCountExport" +
                    "?start_time=" + this.hjh_list_form.start_time +
                    "&end_time=" + this.hjh_list_form.end_time +
                    "&shop_id=" + this.hjh_list_form.shop_id +
                    "&vip_card=" + vip_card +
                    "&vip_name=" + vip_name +
                    "&vip_mobile=" + vip_mobile +
                    "&export_fields=" + JSON.stringify(this.hjh_export_ids) +
                    "&export_type=" + this.hjh_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>